import React from 'react';
import { Link } from 'react-router-dom';

import { getClass } from '../../../utils/component-helpers';
import { session } from '../../../services/session';

import linkout from '../../../images/icons/black-linkout.png';

import './styles/strategy-overview-row.scss';

const performanceMap = {
  publisher_total_earnings: 'Earnings',
  clicks: 'Clicks',
  publisher_epc: 'EPC',
};

const feeTypeMap = {
  marketplace: 'Marketplace',
  direct_deal: 'Direct Deal',
};

const StrategyOverviewRow = ({ strategy, retailer, setModalStrategy, overview }) => {
  const strategyProductsUrl =
    `/v2/publisher/${session.orgId}/new-recs/rates/${strategy.merch_id}` +
    `/strategies/${strategy.strategy_id}`;

  const isInactive = ['expired', 'paused'].includes(strategy.strategy_status);
  const className = `row strategies-row
		${strategy.strategy_name.replace(/ /g, '-').toLowerCase()}
		${isInactive ? 'inactive-strategy' : ''}
	`;

  const strategyIsUpcoming = strategy.status === 'upcoming';
  const strategyRate = strategy.strategy_bid ? strategy.strategy_bid : strategy.commission_rate;

  const displayStrategyRate = !strategyIsUpcoming ? strategyRate : strategyRate || 'Rate TBD';

  const detailsTxt =
    strategy.strategy_status === 'expired'
      ? 'Completed'
      : strategy.strategy_status === 'paused'
      ? 'Paused'
      : displayStrategyRate;

  const detailsClassName = `details-txt ${
    isInactive ? 'inactive' : !strategyIsUpcoming ? 'rate' : 'rate-upcoming'
  }`;

  // Partner name - only show on strategy overview table
  const partner =
    strategy.merchant_name && strategy.merchant_name !== retailer && overview ? (
      <div className="column merchant-name">
        <span className="merch-name">{strategy.merchant_name}</span>
      </div>
    ) : null;

  const feeType = (
    <div className="column fee-type">
      <span>
        <p className="fee-type-label">{feeTypeMap[strategy.fee_type]}</p>
        <p className="secondary-type-label">
          {strategy.fee_type === 'marketplace' ? 'Standard' : null}
        </p>
      </span>
    </div>
  );

  const details = (
    <div className="column details">
      <span className={detailsClassName}>{detailsTxt}</span>
      <span className="dot-date-txt">
        <span
          className={getClass('active-status-dot', {
            active: !isInactive,
            inactive: isInactive,
          })}
        ></span>
        <span
          className={getClass('date-txt', {
            'coming-soon': !isInactive && strategyIsUpcoming,
            'date-txt': !isInactive && !strategyIsUpcoming,
          })}
        >
          {strategy.strategy_date_label}
        </span>
      </span>
    </div>
  );

  // Your Performance
  const performance = parseFloat(strategy.clicks) ? (
    Object.keys(performanceMap).map((key, idx) => {
      const label =
        strategy.merchant_name && strategy.merchant_name !== retailer ? (
          <span>Your {performanceMap[key]}</span>
        ) : null;

      const value = strategyIsUpcoming ? '-' : strategy[key];

      return (
        <div key={idx} className={`${key} sub-column`}>
          <span>{value}</span>
          {label}
        </div>
      );
    })
  ) : (
    <div className="no-stats sub-column">
      <div>No recommendations for this strategy</div>
      <span className={`get-started ${isInactive ? 'inactive' : ''}`}>Click to Get Started</span>
    </div>
  );

  const strategyNameLabelIcon = (
    <div className="column strategy-name">
      <span>
        <div>
          <div
            className="strategy-info-btn"
            onClick={e => {
              e.preventDefault();
              setModalStrategy(strategy);
            }}
          >
            <img src={linkout} alt="link out" className="link-out" />
          </div>
        </div>
        <div className="strategy-name-label">
          <p className={`name ${isInactive ? 'inactive' : ''}`}>{strategy.strategy_name}</p>
          <p className="labels">{strategy.strategy_labels}</p>
        </div>
      </span>
    </div>
  );

  const firstColumn = overview ? partner : strategyNameLabelIcon;
  const secondColumn = overview ? strategyNameLabelIcon : partner;

  const strategyOverviewRow = (
    <>
      {firstColumn}

      {secondColumn}

      {feeType}

      {details}

      <div className={`column performance ${isInactive ? 'inactive' : ''}`}>{performance}</div>
    </>
  );

  const strategyRowContainer = isInactive ? (
    <div className={className}>{strategyOverviewRow}</div>
  ) : (
    <Link className={className} to={strategyProductsUrl}>
      {strategyOverviewRow}
    </Link>
  );

  return strategyRowContainer;
};

export default StrategyOverviewRow;
